import axios from "axios";
import { API_URL } from "../constants";

export const updateStatus = (id, data) => {
  const url = `${API_URL}/review-files/status/${id}`;
  return axios.patch(url, data).then((response) => response.data);
};
